export function SET_BIOACTIVE_SELECTED(state, bioactive) {
  state.bioactiveSelected = bioactive;
}

export function SET_FETCH_BIO_LIST(state, flag) {
  state.fetchBoactiveBankList = flag;
}

export function SET_FETCH_PRESERVED_LIST(state, flag) {
  state.fetchPreservedList = flag;
}

export function SET_SEARCH_BIO(state, flag) {
  state.searchBioactive = flag;
}

export function SET_SREACTIVATION(state, value) {
  state.reactivation = value;
}
